<template>
    <div>
        <div>
            <div class="max-w-screen-2xl tw-mx-auto">
                <internal-header heading="Manage Content" :show-button="false" />
                <div class="tw-flex tw-flex-col">
                    <v-tabs v-model="current_tab" grow active-class="active-tab" slider-size="0" height="50" class="tw-pt-3">
                        <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2 tw-mb-4">Home Page</v-tab>
                        <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2 tw-mb-4">About Us</v-tab>
                        <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2 tw-mb-4">Health & Safety</v-tab>
                        <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2 tw-mb-4">Contact Us</v-tab>
                        <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2 tw-mb-4">Members Area</v-tab>
                        <v-tab class="tw-border-b-2 tw-border-secondary tw-mb-4">File Manager</v-tab>

                        <v-tab-item><website-content-home-page :constants="constants" :nextPriorityProp="nextPriorityProp" :eventPrioritiesProp="eventPrioritiesProp"/></v-tab-item>
                        <v-tab-item><website-content-about-us :constants="constants" :contents="contents" /></v-tab-item>
                        <v-tab-item><website-content-health-safety :constants="constants" :contents="contents" /></v-tab-item>
                        <v-tab-item><website-content-contact-us :constants="constants"/></v-tab-item>
                        <v-tab-item><website-content-members :constants="constants" :contents="contents" :linkCategories="linkCategories" :baseDues="baseDues" /></v-tab-item>
                        <v-tab-item><website-content-file-manager /></v-tab-item>
                    </v-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import WebsiteContentHomePage from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentHomePage";
    import WebsiteContentAboutUs from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentAboutUs";
    import WebsiteContentHealthSafety from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentHealthSafety";
    import WebsiteContentContactUs from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentContactUs";
    import WebsiteContentMembers from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentMembers";
    import WebsiteContentFileManager
        from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentFileManager.vue";

    export default {
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            WebsiteContentFileManager,
            WebsiteContentContactUs,
            WebsiteContentHealthSafety,
            WebsiteContentAboutUs,
            WebsiteContentHomePage,
            WebsiteContentMembers,
            SmartTable,
            InternalHeader,
        },
        props: {
            'nextPriorityProp': {
                type: Number,
                required: false,
                default: 10
            },
            'eventPrioritiesProp': {
                type: Array,
                required: false,
                default: []
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'contents': {
                type: Object,
                required: false,
                default: function () {
                    return {}
                }
            },
            'committees': {
                type: Array,
                required: true,
                default: function () {
                    return []
                }
            },
            'linkCategories': {
                type: Array,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'baseDues': {
                type: String,
                required: false,
                default: function () {
                    return ''
                }
            },
            'traineesDocuments': {
                type: Array,
                required: false,
                default: function () {
                    return []
                }
            },
        },
        data() {
            return {
                titleCarousels: 'Carousel Images',
                editCarouselDialog: false,
                searchCarousels: null,
                carouselSelected: {},

                titleEvents: 'News & Events',
                titleLatest: 'Latest Shows',
                editEventDialog: false,
                searchEvents: null,
                eventSelected: {},
                current_tab: null,
            }
        },
        mounted() {
            //
        },
        computed: {
            headersCarousels() {
                return [
                    {value: 'image_desktop',    text: 'Image',    align: `start`, sortable: false,   filterable: false,   search: null, optional: false, width: '180px' },
                    {value: 'carousel',    text: 'Carousel',      align: `start`, sortable: true,    filterable: true,    search: null, optional: false, width: '180px' },
                    {value: 'title',            text: 'Title',    align: `start`, sortable: true,    filterable: false,   search: null, optional: false, },
                    {value: 'image_color',      text: 'Color',    align: `start`, sortable: true,    filterable: false,   search: null, optional: false, },
                ]
            },

            headersEvents() {
                return [
                    {value: 'image',        text: 'Image',    align: `start`, sortable: false,   filterable: false,   search: null, optional: false, width: '180px' },
                    {value: 'date',         text: 'Date',     align: `start`, sortable: true,    filterable: false,   search: this?.filters?.date, optional: false, width: '180px' },
                    {value: 'title',        text: 'Title',    align: `start`, sortable: true,    filterable: false,   search: this?.filters?.title, optional: false, },
                    {value: 'target',       text: 'Target',   align: `start`, sortable: true,    filterable: false,   search: this?.filters?.target, optional: false, },
                ]
            },
        },
        methods: {
            // Carousels
            refreshCarouselsData() {
                this.$refs.carousels_list.refreshList()
            },
            showCarouselItem(item) {
                this.carouselSelected = item
                this.editCarouselDialog = true
            },
            addCarouselItem() {
                this.carouselSelected = null
                this.editCarouselDialog = true
            },
            // Events
            refreshEventsData() {
                this.$refs.events_list.refreshList()
            },
            showEvent(item) {
                this.eventSelected = item
                this.editEventDialog = true
            },
            addEvent() {
                this.eventSelected = null
                this.editEventDialog = true
            }
        }
    }
</script>

<style scoped>
.active-tab {
    background-color: #ece4df;
    color: #3c47d1 !important;
    font-weight:bold;
}
</style>
